import {
  ArmyListUnitActionState,
  ArmyListUnitState,
  buildArmyListUnitState,
} from '@Stores/index';
import { ArmyListUnit } from '@Models';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ArmyListUnitRequestPayload {
  armyListUnit: ArmyListUnit;
  action: ArmyListUnitActionState;
}

const initialState: ArmyListUnitState = buildArmyListUnitState({
  entity: null,
}) satisfies ArmyListUnitState as ArmyListUnitState;

const armyListUnitSlice = createSlice({
  name: 'army-list-unit',
  initialState,
  reducers: {
    setError(state: ArmyListUnitState, action: PayloadAction<string>) {
      state.errorMessage = action.payload;
      state.hasError = true;
    },
    setLoading(state: ArmyListUnitState, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setArmyListUnit(
      state: ArmyListUnitState,
      action: PayloadAction<ArmyListUnit>,
    ) {
      state.entity = {
        ...action.payload,
      };
      state.id = action.payload.id;
    },
    cancel(state: ArmyListUnitState) {
      state.action = null;
      state.id = null;
      state.entity = null;
    },
    setRequest(
      state: ArmyListUnitState,
      action: PayloadAction<ArmyListUnitRequestPayload>,
    ) {
      state.entity = action.payload.armyListUnit;
      state.id = action.payload.armyListUnit.id;
      state.action = action.payload.action;
    },
    setNotes(state: ArmyListUnitState, action: PayloadAction<string>) {
      state.entity = {
        ...state.entity!,
        notes: action.payload,
      };
    },
    setName(state: ArmyListUnitState, action: PayloadAction<string>) {
      state.entity = {
        ...state.entity!,
        name: action.payload,
      };
    },
    setCreationSuccess(
      state: ArmyListUnitState,
      action: PayloadAction<ArmyListUnit>,
    ) {
      state.entity = action.payload;
      state.id = action.payload.id;
      state.action = ArmyListUnitActionState.Edit;
    },
  },
});

export default armyListUnitSlice;
